export default {
  toasted: {
    welcome_back: 'Welcome Back! You have been away for {sec} seconds',
    date_invaild: 'Date invalid!',
    set_date: 'Set Successfully!'
  },
  level: {
    light: 'Light',
    moderate: 'Moderate',
    terrifying: 'Terrifying',
    wtf: 'WTF?'
  },
  title: {
    motivation: 'Motivation',
    level: 'Level',
    date: 'Date (Like birthday)'
  },
  button: {
    confirm: 'Confirm'
  },
  placeholder: {
    year: 'Year',
    month: 'Month',
    day: 'Day'
  },
  message: {
    default: 'Click to Set Time',
    readme: `<p>Enter a date and see how time flies</p>
        <p><strong>No data will leave your browser</strong></p>
        <p>Motivated by <a href="https://github.com/soffes/Motivation">Motivation</a></p>`
  }
}
